import React from 'react';
//adding new campaign page
const OpenSeaLink = ({ openseaLink }) => {
  return (
        <a
          href={openseaLink}
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer"
        >
          <img
            src={'assets/img/icon/opensea.png'}
            alt="opensea"
            className="cursor-pointer"
            width={30}
          /></a>
       
  );
};

export default OpenSeaLink;
